import { FC } from 'react';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { IDropdownArrowIconProps } from './types';

export const DropdownArrowIcon: FC<IDropdownArrowIconProps> = ({ isOpen, color = 'info', onClick = () => 0 }) => {
  return (
    <>
      {isOpen ? (
        <KeyboardArrowUpIcon color={color} onClick={onClick} />
      ) : (
        <KeyboardArrowDownIcon color={color} onClick={onClick} />
      )}
    </>
  );
};
